module.exports = __webpack_public_path__ + "img/vmware-logo.2a22d3c6.png";